import React from 'react';
import { Outlet } from 'react-router-dom'; 

import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';

const MainLayout = ({ children }) => {
  return (
    <>
    <div className='wrapper'>
      <TopBar />
      <Sidebar />
      <div className="content-wrapper">
      <Outlet /> 
      </div>
      <Footer />
      </div>
    </>
  );
};

export default MainLayout;
